import axios from "../components/utils/Interceptors"

const getDataById = async (url, id) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const baseUrl = `${process.env.REACT_APP_APIURL}/${url}/${id}`;

  const res = await axios.get(`${baseUrl}`, {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${user.token}`,
    },
  });

  const response = await res.data;

  return response;
};

export default getDataById;
